const Export = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 37.84 34.4"
  >
    <g id="Layer_116" data-name="Layer 116" transform="translate(-1 -1)">
      <path
        id="Path_650"
        data-name="Path 650"
        d="M28.278,19.081a1.723,1.723,0,0,1-.034,2.425L24.8,24.843a1.806,1.806,0,0,1-1.2.482,1.875,1.875,0,0,1-.671-.138A1.72,1.72,0,0,1,21.88,23.6v-1.72H16.72a1.72,1.72,0,1,1,0-3.44h5.16v-1.72a1.72,1.72,0,0,1,2.958-1.2Z"
        transform="translate(10.08 10.076)"
        fill="inherit"
      />
      <path
        id="Path_651"
        data-name="Path 651"
        d="M38.84,11.32v8.6a1.72,1.72,0,0,1-1.72,1.72H31.96A10.32,10.32,0,0,0,21.64,31.96a1.72,1.72,0,0,1-1.72,1.72H6.057A5.057,5.057,0,0,1,1,28.623V6.16A5.16,5.16,0,0,1,6.16,1h8.48a5.16,5.16,0,0,1,4.266,2.27L20.333,5.4a1.72,1.72,0,0,0,1.445.757h11.9a5.16,5.16,0,0,1,5.16,5.16Z"
        transform="translate(0 0)"
        fill="inherit"
      />
    </g>
  </svg>
);

export default Export;
